export default (projectName: string) => `{
  "name": "${projectName}",
  "version": "0.1.0",
  "private": true,
  "scripts": {
    "dev": "neex dev src/server.ts",
  "build": "neex build",
    "start": "neex start"
  },
  "dependencies": {
    "express": "^5.1.0",
    "neex": "^0.7.20",
    "cors": "^2.8.5",
    "dotenv": "^17.2.0",
    "@prisma/client": "^6.11.1"
  },
  "devDependencies": {
    "typescript": "^5.8.3",
    "@types/express": "^5.0.3",
    "@types/cors": "^2.8.19",
    "@types/node": "^22.15.17",
    "prisma": "^6.11.1"
  }
}`;
